const isUnsetTime = (value) => value == null || value === '';
const isUnsetRatio = (value) => value == null || value === '';

/**
 * Map every defined API recipe-type setting to its form field.
 */
export const getAllRecipeTypeDefaults = (settings) => {
	if (!settings) {
		return {};
	}

	const defaults = {};

	if (settings.waterRatio != null) {
		defaults.waterRatio = settings.waterRatio;
	}
	if (settings.weightRatio != null) {
		defaults.weightRatio = settings.weightRatio;
	}
	if (settings.steamTime != null) {
		defaults.steamConfiguration = settings.steamTime;
	}
	if (settings.blendTime != null) {
		defaults.blendConfiguration = settings.blendTime;
	}

	return defaults;
};

/**
 * Return only recipe-type defaults that have not already been set on the form.
 */
export const getRecipeTypeDefaults = (values, settings, includeRatios = false) => {
	if (!settings) {
		return {};
	}

	const defaults = {};

	if (includeRatios && settings.waterRatio != null && isUnsetRatio(values.waterRatio)) {
		defaults.waterRatio = settings.waterRatio;
	}
	if (includeRatios && settings.weightRatio != null && isUnsetRatio(values.weightRatio)) {
		defaults.weightRatio = settings.weightRatio;
	}
	if (settings.steamTime != null && isUnsetTime(values.steamConfiguration)) {
		defaults.steamConfiguration = settings.steamTime;
	}
	if (settings.blendTime != null && isUnsetTime(values.blendConfiguration)) {
		defaults.blendConfiguration = settings.blendTime;
	}

	return defaults;
};
